<template>
  <div>
    <el-row class="search-box">
      <el-input v-model.trim="sn" placeholder="请扫改造订单号" @keyup.enter="search" class="input"></el-input>
      <el-button :loading="loading" @click="search">查询</el-button>
      <KfMessage ref="searchMessage"/>
    </el-row>

    <el-card shadow="never">
      这里展示订单信息，如：发货单号、服务模式、发货箱数、发货物品总数、实际接收箱数、外观损坏箱数、<br>
      已拆箱数、接收状态(待拆箱、拆箱中、拆箱完成)等
    </el-card>

    <FrameForm component-param="rebuild_station_check_in"></FrameForm>

  </div>
</template>

<script>
export default {
  name: "StationCheckIn",
  data() {
    return {
      loading: false,

    }
  }
}
</script>

<style scoped>
.input {
  height: 32px;
  width: 250px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}
</style>